import React, { useState, useEffect } from "react";
import ButtonImageLoading from "../assets/images/button-image-loading.svg";

interface IDAQuestionFieldImageProps {
    imgUrl: string;
}

const DAQuestionFieldImage: React.FC<IDAQuestionFieldImageProps> = (props) => {
    const { imgUrl } = props;

    const [imgLoaded, setImgLoaded] = useState(false);

    const onLoad = (): void => {
        setImgLoaded(true);
    };

    return (
        <React.Fragment>
            {!imgLoaded && <img src={ButtonImageLoading} />}
            <img
                style={imgLoaded ? {} : { display: "none" }}
                src={imgUrl}
                onLoad={onLoad}
            />
        </React.Fragment>
    );
};

export default DAQuestionFieldImage;
